import { ReactNode } from 'react';
import classnames from 'classnames';

import './Block.scss';

type Props = {
  children: ReactNode;
  className?: string;
  testId?: string;
};

export const BlockGroup = ({ children, className, testId }: Props) => (
  <div className={classnames('block-group', className)} data-test={testId}>
    {children}
  </div>
);
